import { isDevMode } from '@angular/core';

/**
 * Configures console logging behavior based on the environment.
 * In production mode, all console methods are replaced with no-op functions.
 * In development mode, console methods remain untouched.
 */
export class LoggerConfig {
  private static isConfigured = false;

  /**
   * Initializes the logger configuration.
   * Should be called in the app's main module.
   */
  static init(): void {
    if (this.isConfigured) return;

    if (!isDevMode()) {
      const noop = () => {};
      console.log = noop;
      console.info = noop;
      console.warn = noop;
      console.debug = noop;
    }

    this.isConfigured = true;
  }
}
